import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core'
import { OpeningHours } from '../domain/OpeningHours'
import { Time } from '../domain/Time'

const weekdays = [
    { dayOfWeek: 1, day: 'Monday' },
    { dayOfWeek: 2, day: 'Tuesday' },
    { dayOfWeek: 3, day: 'Wednesday' },
    { dayOfWeek: 4, day: 'Thursday' },
    { dayOfWeek: 5, day: 'Friday' },
    { dayOfWeek: 6, day: 'Saturday' },
    { dayOfWeek: 7, day: 'Sunday' },
]

@Pipe({
    name: 'openingHours',
    standalone: true,
})
export class OpeningHoursPipe implements PipeTransform {

    private readonly timeFormatter: Intl.DateTimeFormat

    constructor(@Inject(LOCALE_ID) locale: string) {
        this.timeFormatter = new Intl.DateTimeFormat(locale, {
            hour: '2-digit',
            minute: '2-digit',
        })
    }

    transform(openingHours: OpeningHours | null | undefined) {
        if (openingHours === null || openingHours === undefined) {
            return []
        }
        const days = new Map(openingHours.days.map(day => [day.dayOfWeek, day]))
        return weekdays.map(weekday => {
            const periods = [...(days.get(weekday.dayOfWeek)?.periods ?? [])]
                .sort((first, second) => first.start.toString().localeCompare(second.start.toString()))
            return {
                ...weekday,
                times: periods.map(period =>
                    ({
                        start: this.formatTime(period.start),
                        end: this.formatTime(period.end),
                    })
                ),
            }
        })
    }

    private formatTime(time: Time): string {
        return this.timeFormatter.format(new Date(2000, 0, 1, time.hours, time.minutes))
    }
}
